const MANAGER_HIDDEN_SECTIONS = new Set(['business.settings', 'system.settings']);
const MANAGER_HIDDEN_URL_PREFIXES = ['users'];
const MANAGER_RESTRICTED_PATH_PREFIXES = [
  '/users',
  '/user',
  '/user-clone',
];

export const sanitizeUserUrls = (role, urls = []) => {
  if (!Array.isArray(urls)) {
    return [];
  }

  if (role !== 'manager') {
    return urls;
  }

  const sanitizeItems = (items) =>
    items.reduce((result, item) => {
      if (!item) {
        return result;
      }

      const isHiddenSection = MANAGER_HIDDEN_SECTIONS.has(item?.name);
      const isHiddenUrl = MANAGER_HIDDEN_URL_PREFIXES.some((prefix) =>
        String(item?.url || '').startsWith(prefix),
      );

      if (isHiddenSection || isHiddenUrl) {
        return result;
      }

      const nextItem = { ...item };

      if (Array.isArray(item?.submenu)) {
        nextItem.submenu = sanitizeItems(item.submenu);
      }

      if (Array.isArray(item?.children)) {
        nextItem.children = sanitizeItems(item.children);
      }

      result.push(nextItem);
      return result;
    }, []);

  return sanitizeItems(urls);
};

const collectRestrictedRouteMatchers = (items = [], result = []) => {
  items.forEach((item) => {
    if (!item) {
      return;
    }

    const hasNestedRoutes =
      Boolean(item?.submenu?.length) || Boolean(item?.children?.length);

    if (item.url) {
      result.push({
        path: `/${String(item.url).replace(/^\/+/, '')}`,
        exactOnly: hasNestedRoutes,
      });
    }

    if (Array.isArray(item?.submenu)) {
      collectRestrictedRouteMatchers(item.submenu, result);
    }

    if (Array.isArray(item?.children)) {
      collectRestrictedRouteMatchers(item.children, result);
    }
  });

  return result;
};

export const isManagerRestrictedPath = (pathname, urls = []) => {
  if (!pathname) {
    return false;
  }

  const normalizedPath =
    pathname !== '/' ? pathname.replace(/\/+$/, '') : pathname;

  if (
    MANAGER_RESTRICTED_PATH_PREFIXES.some(
      (prefix) =>
        normalizedPath === prefix || normalizedPath.startsWith(`${prefix}/`),
    )
  ) {
    return true;
  }

  const restrictedSections = Array.isArray(urls)
    ? urls.filter((item) => MANAGER_HIDDEN_SECTIONS.has(item?.name))
    : [];

  return collectRestrictedRouteMatchers(restrictedSections).some(
    ({ path, exactOnly }) =>
      normalizedPath === path ||
      (!exactOnly && normalizedPath.startsWith(`${path}/`)),
  );
};
